import { z } from "zod";
import { pageQuery, trimmed, uuid } from "./common";

/**
 * Сообщения от Coca клиентам (Platform Admin «Рассылки»): одной, нескольким или всем компаниям, всем сотрудникам или
 * только выбранным ролям. Приходит в колокольчик ERP (тип уведомления `platform.message`), по желанию — в Telegram и на почту.
 */
export const platformBroadcastSchema = z
  .strictObject({
    title: trimmed(1, 120),
    body: trimmed(1, 3000),
    /** all — всем работающим клиентам, companies — выбранным */
    target: z.enum(["all", "companies"]),
    companyIds: z.array(uuid).max(500).default([]),
    /** Коды ролей (owner, branch_manager, cashier… или своя роль компании); пусто — всем сотрудникам */
    roles: z.array(z.string().trim().min(1).max(64)).max(50).default([]),
    telegram: z.boolean().default(true),
    email: z.boolean().default(false),
  })
  .refine((v) => v.target === "all" || v.companyIds.length > 0, { error: "Выберите хотя бы одну компанию", path: ["companyIds"] });
export type PlatformBroadcastInput = z.input<typeof platformBroadcastSchema>;

export const platformBroadcastsQuery = pageQuery;
/** Роли для выбора: системные; с `companyId` — плюс свои роли этой компании */
export const platformBroadcastRolesQuery = z.object({ companyId: uuid.optional() });
